import type { User } from '@supabase/supabase-js';

export type StaffRole = 'agent' | 'admin' | 'super_admin' | 'manager';

export function isStaffRole(role: string | null | undefined): role is StaffRole {
  return role === 'agent' || role === 'admin' || role === 'super_admin' || role === 'manager';
}

export function isPropellerDomain(email: string | null | undefined): boolean {
  if (!email) return false;
  return email.toLowerCase().endsWith('@propellertravel.com');
}

export function hasGoogleIdentity(user: User | null | undefined): boolean {
  if (!user) return false;

  const provider = (user as any)?.app_metadata?.provider as string | undefined;
  if (provider === 'google') return true;

  const providers = (user as any)?.app_metadata?.providers as string[] | undefined;
  if (Array.isArray(providers) && providers.includes('google')) return true;

  const identities = (user as any)?.identities as Array<{ provider?: string }> | undefined;
  if (Array.isArray(identities) && identities.some((i) => i?.provider === 'google')) return true;

  return false;
}











